import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Icon from "@material-ui/core/Icon";
import GoogleMapsWithControls from "./GoogleMapsWithControls";

import AlertDialogYesNo from "../AlertDialogYesNo";

import { MUI_STYLES } from "../constants";
import AppContext from "../AppContext";
const styles = MUI_STYLES;

class ProjectPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changed: false,
      showDeleteDialog: false,
      showSuccess: false
    };
  }

  ProcessingStatus(projectData) {
    if (projectData.isProcessed)
      return (
        <span>
          <strong>State:</strong> Processed
        </span>
      );
    return (
      <span>
        <strong>State:</strong> In progress
      </span>
    );
  }

  UploadDate(projectData) {
    return (
      <span>
        
        {new Date(projectData.uploadStart).toLocaleDateString()}
       
       
      </span>
    );
  }

  setStateCallback = project => {
    this.setState({ changed: true });

    Object.assign(this.props.projectData, project);
    /*     console.log("props.projectData", this.props.projectData);
    console.log("props.projectData", project);
    console.log("set state callback in project panel", this.state, this.props);
 */
  };

  setStateCallback = project => {
    this.setState({ changed: true });
    Object.assign(this.props.projectData, project);
  };

  openModel = async () => {
    this.setState({loading: true});
    await this.props.openModelCallback(this.props.projectData);
    this.setState({loading: false});
  };
  save = async () => {
    this.setState({ changed: false, loading: true });
    await this.props.saveEditCallback(this.props.projectData);
    this.setState({ loading: false });
  };
  remove = async () => {
    await this.props.removeCallback(this.props.projectData);
  };

  hideModals = () => {
    this.setState({ showSuccess: false, showDeleteDialog: false });
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.props;
    const { projectData } = this.props;
    const { handleExpandChange } = this.props;

    //    console.log("projectData", this.props.projectData);
    //    console.log("projects", this.props.projects);
    return (
      <div className={classes.root}>
        <ExpansionPanel
          key={projectData.projectKey}
          expanded={expanded === projectData.projectKey}
          onChange={handleExpandChange(projectData)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {projectData.projectName}
              </Typography>
            </div>
            <div className={classes.column}>
              <Typography className={classes.secondaryHeading}>
               <small> {this.UploadDate(projectData)}</small>
              </Typography>
            </div>
            <div className={classes.column}>
              <Typography className={classes.secondaryHeading}>
              {this.ProcessingStatus(projectData)}  
              </Typography>
            </div>
            
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            <div className={classes.wideColumn}>
              <Typography className={classes.typography}>
                Edit model position and rotation
                <Button
                  aria-owns={
                    Boolean(this.state.infoAnchorEl)
                      ? "simple-popper"
                      : undefined
                  }
                  aria-haspopup="true"
                  onClick={event => {
                    this.setState({
                      infoAnchorEl: event.currentTarget
                    });
                  }}
                >
                  <Icon>info</Icon>
                </Button>
              </Typography>
              <Popover
                id="simple-popper"
                open={Boolean(this.state.infoAnchorEl)}
                anchorEl={this.state.infoAnchorEl}
                onClose={() => {
                  this.setState({ infoAnchorEl: null });
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }}
              >
                <Typography className={classes.typography}>
                  Click on the map to set the model position. Zoom closer for
                  more precision and rotation controls.
                </Typography>
              </Popover>
              <GoogleMapsWithControls
                projectData={projectData}
                setStateCallback={this.setStateCallback}
              />
            </div>
          </ExpansionPanelDetails>

          <ExpansionPanelActions>
          <AdornedButton
              size="small"
              color="primary"
              variant="contained"
              onClick={this.openModel}
              disabled={!this.props.projectData.webglSupported}

            >
              &nbsp;&nbsp;{this.state.loading ? "Opening" : "Open 3D model"}
              &nbsp;&nbsp;
            </AdornedButton>
            <AdornedButton
              size="small"
              color="primary"
              variant="contained"
              onClick={() => {
                this.setState({ showDeleteDialog: true });
              }}
              loading={this.state.loading}
            >
              &nbsp;&nbsp;{this.state.loading ? "Deleting" : "Delete"}
              &nbsp;&nbsp;
            </AdornedButton>
            <AdornedButton
              size="small"
              color="primary"
              variant="contained"
              onClick={this.save}
              disabled={!this.state.changed}
              loading={this.state.loading}
            >
              &nbsp;&nbsp;{this.state.loading ? "Saving" : "Save"}
              &nbsp;&nbsp;
            </AdornedButton>
          </ExpansionPanelActions>
          <AlertDialogYesNo
            title="Delete project"
            handleClose={() => {
              this.hideModals();
            }}
            handleConfirm={() => {
              this.remove();
            }}
            open={this.state.showDeleteDialog}
            description={
              <span>Do you really want to delete this project?</span>
            }
          />
        </ExpansionPanel>
      </div>
    );
  }
}
ProjectPanel.contextType = AppContext;

export default withStyles(styles)(ProjectPanel);

const SpinnerAdornment = withStyles(styles)(props => (
  <CircularProgress className={props.classes.spinner} size={20} />
));

const AdornedButton = props => {
  const { children, loading, ...rest } = props;
  return (
    <Button {...rest}>
      {children}
      {loading && <SpinnerAdornment {...rest} />}
    </Button>
  );
};
